/* import __COLOCATED_TEMPLATE__ from './category-name-fields.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
